module.exports = __webpack_public_path__ + "img/hero-section-search.377faeac.svg";